import { render, staticRenderFns } from "./CloseTable.vue?vue&type=template&id=316711d6&scoped=true"
import script from "./CloseTable.vue?vue&type=script&lang=js"
export * from "./CloseTable.vue?vue&type=script&lang=js"
import style0 from "./CloseTable.vue?vue&type=style&index=0&id=316711d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316711d6",
  null
  
)

export default component.exports